// HOC
import{withFeatureState}from'./state';import{Delete}from'components/v2/FlexTable/RowActionItem';export var ConnectedDelete=withFeatureState(Delete);